import { render, staticRenderFns } from "./aiHeader.vue?vue&type=template&id=7a8d050d&scoped=true"
import script from "./aiHeader.vue?vue&type=script&lang=js"
export * from "./aiHeader.vue?vue&type=script&lang=js"
import style0 from "./aiHeader.vue?vue&type=style&index=0&id=7a8d050d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8d050d",
  null
  
)

export default component.exports